// const baseUrl = "http://localhost:8000/"
// const baseUrl = "https://jutexx-production.up.railway.app/"

const baseUrl = "https://api.jutexx.com/"
// const baseUrl = "https://api-rw.jutexx.com/"

export default baseUrl